<template>
    <div id="new_staff">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div class="contents">
            <div class="ui form" :class="{'loading': is_loading}">
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.username') }} <span>*</span></label>
                    <input type="text" name="username" v-model="staff.username">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.password') }} <span>*</span></label>
                    <input type="password" name="password" v-model="staff.password">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.password_confirmation') }} <span>*</span></label>
                    <input type="password" autocomplete="off" name="password_confirmation" v-model="staff.password_confirmation">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.name') }} <span>*</span></label>
                    <input type="text" name="name" v-model="staff.name">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.phone') }}</label>
                    <input type="text" name="phone" v-model="staff.phone">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.email') }}</label>
                    <input type="email" name="email" v-model="staff.email">
                </div>
                <div class="field" v-if="roles">
                    <label>{{ $t('models.attributes.staffs.role') }} <span>*</span></label>
                    <select class="ui dropdown" v-dropdown v-model="staff.role_identity">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="role in $store.state.provider.staffs_module.roles" :value="role.identity">{{ role.name }}</option>
                    </select>
                </div>

                <div class="field">
                    <label>{{ $t('models.attributes.staffs.theme_name') }} <span>*</span></label>
                    <select class="ui dropdown" v-dropdown v-model="staff.theme_name">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="theme_name in $store.state.provider.theme_menu_keys" :value="theme_name">{{ $t('ui.theme_names.' + theme_name) }}</option>
                    </select>
                </div>
                <div class="field">
                    <label>
                        {{ $t('models.attributes.staffs.station') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="staff.station_identity"
                            @click="
                                staff.station_identity = null;
                                $($refs.station_identity).dropdown('clear');
                            ">
                        </i>
                    </label>
                    <select class="ui dropdown" v-dropdown v-model="staff.station_identity" ref="station_identity">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="station in $store.state.provider.stations" :value="station.identity">
                            {{ station.name }}
                        </option>
                    </select>
                </div>

                <div class="ui basic positive button" @click="create_staff">
                    {{ $t('ui.general.submit') }}
                </div>
                <router-link :to="{name: 'staffs'}" class="ui basic button">
                    <i class="undo icon"></i>
                    {{ $t('ui.general.back') }}
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "NewStaff",
    data() {
        return {
            is_loading: false,
            staff: {
                name: null,
                username: null,
                email: null,
                phone: null,
                password: null,
                password_confirmation: null,
                role_identity: null,
                theme_name: null,
                station_identity: null,
            },
            errors: [],
        }
    },
    mounted() {
        this.form_validation()
    },
    computed: {
        operator() {
            return this.$store.state.provider.staffs_module.operator
        },
        roles() {
            return this.$store.state.provider.staffs_module.roles
        },
    },
    methods: {
        create_staff() {
            var staff = _.clone(this.staff)
            this.errors = []

            if (staff.username && staff.password && staff.password_confirmation && staff.name && staff.role_identity && staff.theme_name) {
                if (staff.password != staff.password_confirmation) {
                    this.errors.push("請檢查密碼與確認密碼是否一致")
                } else {
                    var url = this.$store.state.provider.routes.api_v1_provider_staffs_create

                    this.is_loading = true
                    axios.post(url, staff, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                        .then(response => {
                            if (response.data.status == "success") {
                                this.$router.push({name: 'staffs'})
                            } else {
                                console.log(response.data)
                                this.errors = response.data.errors
                                // this.$noty.error('無法建立staff')
                                this.$noty.error(
                                    this.$t('ui.notifications.error.create__name', {
                                        name: this.$t('models.staffs')
                                    })
                                )
                            }
                        })
                        .catch(error => {
                            console.log(error.response)
                        })
                        .then(() => {
                            this.is_loading = false
                        })

                }
            } else {
                this.errors.push(
                    this.$t('ui.notifications.error.please_check_to_write_in_the_required_fields_mark')
                )
            }
        },
        form_validation() {
            $('.ui.form').form({
                on: 'blur',
                fields: {
                    username: "empty",
                    password: "empty",
                    password_confirmation: "empty",
                    name: "empty",
                    role_identity: "empty",
                }
            })
        }
    },
    components: {
        ErrorMessages,
    }
}
</script>

<style scoped lang="scss">
    @import "../../.assets/stylesheets/form.scss";
</style>
